module.exports = __webpack_public_path__ + "img/man_and_lorry.080e8bfb.jpg";